import React from 'react'
import PropTypes from 'prop-types'
import moment from './moment'

/**
 * Create a React Day Calendar Header component
 *
 * @param {import('./interfaces').DayCalendarHeaderProps} props
 * @returns {JSX.Element}
 */
export default function DayCalendarHeader (props) {
  const { firstDayOfWeek } = props
  const localeData = moment.localeData()
  const WEEKDAYS_SHORT = localeData.weekdaysMin().map(d => d.slice(0, 1))
  const WEEKDAYS = localeData.weekdays().slice()

  return (
    <thead>
      <tr>
        {WEEKDAYS.map((_, index) => (
          <th
            scope='col'
            key={index}
            abbr={WEEKDAYS[(index + firstDayOfWeek) % 7]}
            aria-label={WEEKDAYS[(index + firstDayOfWeek) % 7]}
          >
            {WEEKDAYS_SHORT[(index + firstDayOfWeek) % 7]}
          </th>
        ))}
      </tr>
    </thead>
  )
}

DayCalendarHeader.propTypes = {
  firstDayOfWeek: PropTypes.number
}

DayCalendarHeader.defaultProps = {
  firstDayOfWeek: 1
}
